import React, { Component } from 'react';
import './scheduleHeader.scss';

/** displays a survey form for a participant to fill out, only valid to fill out once */
class ScheduleHeaderComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      day: new Date(),
    }
  }

  render() {
    const LeftArrow = () => {
      return (
        <svg width="1em" height="1em" viewBox="0 0 10 16">
          <path
            d="M 3.36,8.003 9.728,2.018 a -0.842,0.842 0 0 0 0,-1.238 L 9.17,0.256 A -0.954,0.954 0 0 0 8.512,0 C 8.262,0 8.029,0.09 7.853,0.256 L 0.272,7.382 a -0.842,0.842 0 0 0 0,1.243 l 7.574,7.12 A -0.954,0.954 0 0 0 8.505,16 -0.955,0.955 0 0 0 9.163,15.744 L 9.721,15.22 a -0.84,0.84 0 0 0 0,-1.238 L 3.361,8.003 Z"
            fillRule="nonzero"
          />
        </svg>
      );
    };

    return (
      <div className="appointments-header">
        <button id="back-btn" onClick={() => window.location.href = this.props.location}><LeftArrow /></button>
        <h2>Appointments</h2>
        <button id="request-appt" onClick={() => window.location.href = '/requestappointments'} className='ssg-forms-btn ssg-forms-btn-primary  request-button'>
          Request Appointment
        </button>
      </div>
    )
  }
}

export default ScheduleHeaderComponent;



// WEBPACK FOOTER //
// src/scheduler/scheduleHeader/scheduleHeader.component.js